import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { setUserDetails } from '../../../store/Slices/userSlice.js';
import { SendIBRequestApi, GetIBRequestStatusApi } from '../../../api/request/dashboard.js';
import LoadableButton from '../../buttons/LoadableButton.jsx';
import ConfirmationModal from '../../modals/ConfirmationModal.jsx';
import ModalComponent from '../../modals/ModalComponent.jsx';
import { handleApiError } from '../../../utils/handleApiError.js';
import { canSwitchIbDashboard } from '../../../utils/onboarding.js';

const headerButtonClass = 'bg-primary text-white text-sm font-semibold h-9 px-4 rounded-lg themeHover duration-500 whitespace-nowrap inline-flex items-center justify-center';

const MobileIbRequest = () => {
    const dispatch = useDispatch();
    const { userDetails } = useSelector((state) => state.user);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isIbReqLoading, setIsIbReqLoading] = useState(false);
    const [isIbPendingModalOpen, setIsIbPendingModalOpen] = useState(false);
    const [isIbApprovedModalOpen, setIsIbApprovedModalOpen] = useState(false);
    const [isIbReqStatusLoading, setIsIbReqStatusLoading] = useState(false);

    const isPending = userDetails?.ibRequestStatus === 'Pending';
    const isAlreadyIb = canSwitchIbDashboard(userDetails);
    const canRequest = !isPending && !isAlreadyIb;

    const sendIbRequest = async () => {
        try {
            setIsIbReqLoading(true);
            const params = {
                userId: userDetails?._id,
                isIBUser: true,
            };
            const { data } = await SendIBRequestApi(params);
            if (data?.success) {
                dispatch(setUserDetails({ ...userDetails, ibRequestStatus: 'Pending' }));
                toast.success(data?.message);
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setIsIbReqLoading(false);
            setIsModalOpen(false);
        }
    };

    const checkRequestStatus = async () => {
        try {
            setIsIbReqStatusLoading(true);
            const { data } = await GetIBRequestStatusApi(userDetails?._id);
            if (data?.success) {
                if (data?.data?.ibRequestStatus === 'Pending') {
                    setIsIbPendingModalOpen(true);
                }
                if (data?.data?.ibRequestStatus === 'Rejected') {
                    dispatch(setUserDetails({ ...userDetails, ibRequestStatus: 'Rejected' }));
                }
                if (data?.data?.ibRequestStatus === 'Approved') {
                    setIsIbApprovedModalOpen(true);
                    dispatch(setUserDetails({ ...userDetails, ibRequestStatus: 'Approved', referralCode: data?.data?.referralCode, roleName: "IBUser" }));
                    setTimeout(() => {
                        setIsIbApprovedModalOpen(false);
                    }, 2000);
                }
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setIsIbReqStatusLoading(false);
        }
    };

    if (!canRequest && !isPending) {
        return null;
    }

    return (
        <>
            {canRequest && (
                <button className={headerButtonClass} onClick={() => setIsModalOpen(true)}>
                    Become an IB
                </button>
            )}
            {isPending && (
                <LoadableButton
                    className={headerButtonClass}
                    disabled={isIbReqStatusLoading}
                    lable='IB Status'
                    isLoading={isIbReqStatusLoading}
                    onClick={checkRequestStatus}
                    loadingLable='Checking...'
                />
            )}
            <ConfirmationModal
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
                type='success'
                message='Are you sure you want to send IB Request?'
                onConfirm={sendIbRequest}
                isLoading={isIbReqLoading}
                loadingLabel='Sending Request...'
            />
            <ModalComponent isOpen={isIbPendingModalOpen} setIsOpen={setIsIbPendingModalOpen} title='IB Request Status'>
                <div>
                    <p className='font-bold text-[#2F2B3D] text-xl'>Your IB request is under proccess...</p>
                    <p className="mt-4 text-lg">Please wait our admin team is working on your request.</p>
                </div>
            </ModalComponent>
            <ModalComponent isOpen={isIbApprovedModalOpen} setIsOpen={setIsIbApprovedModalOpen} title='IB Request Status'>
                <div>
                    <p className='font-bold text-[#2F2B3D] text-xl'>Congratulations...</p>
                    <p className="mt-4 text-lg">Your IB Request is approved.</p>
                </div>
            </ModalComponent>
        </>
    );
};

export default MobileIbRequest;
